// How many events and news posts the home page shows, as webadmin sets them:
// site.json publishes `home: { maxEvents, maxNews, maxCollaborations }`.
//
// The content contract (@zivin-labs/site-content 0.2.1) doesn't type `home`
// on SiteConfig yet, though the publisher sends it — hence reading it from an
// unknown here rather than a typed field.
import { useSiteChrome } from "./siteContent";

/** Used for any limit webadmin doesn't publish as a positive whole number. */
export const HOME_LIMIT_FALLBACK = 8;

export interface HomeLimits {
  maxEvents: number;
  maxNews: number;
}

function limit(value: unknown): number {
  return typeof value === "number" && Number.isInteger(value) && value > 0 ? value : HOME_LIMIT_FALLBACK;
}

export function homeLimits(site: unknown): HomeLimits {
  const home = (site as { home?: Record<string, unknown> } | null)?.home;
  return { maxEvents: limit(home?.maxEvents), maxNews: limit(home?.maxNews) };
}

export function useHomeLimits(): HomeLimits {
  return homeLimits(useSiteChrome().site);
}
